export const TASKS_URL_ID = 't'
export const GOALS_URL_ID = 'g'
export const OUTCOMES_URL_ID = 'o'
export const SPACES_URL_ID = 's'
export const TEAMS_URL_ID = 'teams'
export const MY_TASKS_URL_ID = 'my-tasks'
export const CHECKLISTS_URL_ID = 'checklists'
export const LEARNING_POINTS_URL_ID = 'lp'
export const IDEATION_URL_ID = 'i'
export const FOLDER_URL_ID = 'f'

export const BOARD_QUERY_ID = 'b'
export const TEAM_QUERY_ID = 'te'

// NOTE: IDEATION
export const IDEAS_TAB_QUERY_ID = 'tab'
export const BLOCK_QUERY_ID = 'block'

//NOTE: VIEWS
export const VIEW_QUERY_ID = 'view'

export const HOME_SITE_URL = 'https://www.floww.ai/'
